import { Control, FieldErrors } from 'react-hook-form';
import { UseFormRegister } from 'react-hook-form/dist/types/form';

import { FormRow } from '../../../components/common/Forms/Forms.styled';
import { CommonInput } from '../../../components/common/Forms/Input';
import { useCommonTranslation } from '../../../hooks/i18n/useCommonTranslation';
import { getHookFormTyped } from '../../../utils/helpers';
import { SiteSettings } from '../../../types/sites';
import {
  isNhsNumberRequired,
  isPostCodeRequired,
  shouldRenderNhsNumber,
} from '../../../utils/siteUtils';
import { useSiteValidationRules } from '../../../hooks/patient/useUserSiteValidationRules';

export type NhsPostcodeForm = {
  postcode?: string;
  nhs_number?: string;
} & { [key: string]: any };

interface IPatientNhsAndPostcodeDataProps<T extends NhsPostcodeForm> {
  register: UseFormRegister<T>;
  control: Control<T>;
  errors: FieldErrors<T>;
  siteSettings: SiteSettings;
}

export const PatientNhsPostcodeData = <T extends NhsPostcodeForm>({
  siteSettings,
  ...rest
}: IPatientNhsAndPostcodeDataProps<T>) => {
  const { register, errors } = getHookFormTyped<NhsPostcodeForm, T>(rest);

  const { t } = useCommonTranslation();
  const { nhsNumberRules, postcodeRules } = useSiteValidationRules({
    siteSettings,
  });

  return (
    <>
      {siteSettings && isPostCodeRequired(siteSettings) && (
        <FormRow>
          <CommonInput
            label={t('postcode')}
            placeholder={t('postcode')}
            {...register('postcode', postcodeRules)}
            helperText={errors.postcode?.message}
            hasError={Boolean(errors?.postcode)}
            required
            autoComplete="postal-code"
          />
        </FormRow>
      )}
      {siteSettings && shouldRenderNhsNumber(siteSettings) && (
        <FormRow>
          <CommonInput
            label={t('nhs-number')}
            placeholder={t('nhs-number')}
            {...register('nhs_number', nhsNumberRules)}
            helperText={errors?.nhs_number?.message}
            hasError={Boolean(errors?.nhs_number)}
            required={isNhsNumberRequired(siteSettings)}
          />
        </FormRow>
      )}
    </>
  );
};
